import React from 'react';
import moment from 'moment';
import Icon from '../../../../Icon';
import { Tooltip } from 'antd';
import StoreOverviewStat from './components/StoreOverviewStat';
import Skeleton from './skeleton';
import './styles.less';

const StoreOverview = ({ skeleton, result }) => {

  const productsCount = result?.metaData?.['published_products_count'];

  const statBlocks = [
    { title: 'Store creation date', value: moment(result?.storeInternalData?.store_info?.created_at).format('MMM DD, YYYY') },
    { title: 'Store products', value: productsCount || result?.storeInternalData?.store_info?.products_count, view: true },
    { title: 'Store collections', value: result?.metaData?.published_collections_count, view: true },
    { title: 'Shipping countries', value: result?.metaData?.ships_to_countries?.length },
    { title: 'Store language', value: result?.storeInternalData?.store_info?.language },
  ];

  function handleSocialChannels(data) {
    const length = data?.length;
    if (length <= 3) {
      return data?.map(el => (
        <Tooltip title={el?.platform.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} key={el?.platform} placement={'top'}>
          <a key={el?.platform}
             href={el?.link ? el?.link : '#'}
             target="_blank"
             rel="noopener noreferrer"
          >
            <Icon role={'button'} type={`search_${el?.platform}`} />
          </a>
        </Tooltip>
      ))
    } else {
      const [a,b,c,...rest] = data;
      return <>
        {
          [a,b,c]?.map(el => (
          <Tooltip title={el?.platform.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} key={el?.platform} placement={'top'}>
            <a key={el?.platform}
               href={el?.link ? el?.link : '#'}
               target="_blank"
               rel="noopener noreferrer"
            >
              <Icon role={'button'} type={`search_${el?.platform}`} />
            </a>
          </Tooltip>
        ))
        }
        <Tooltip title={rest.map(el => el?.platform).join(', ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} placement={'topLeft'}>
          <span className={'more-channels-skip'}>
            {rest.length}
          </span>
        </Tooltip>
      </>
    }
  }

  if (skeleton) return <Skeleton />

  return (
    <div className="overview-block store-overview">
      <div className="stats-wrapper">
        {
          statBlocks.map((item, index) => <StoreOverviewStat data={item} key={index} shopUrl={result?.metaData?.url} />)
        }
        {
          result?.storeInternalData?.total?.social_channels?.length > 0 ?
            <div className={'store-overview-stat-wrapper channels-wrapper'}>
              <div className={'title'}>
                Social Channels
              </div>
              <div className={'value'}>
                {
                  handleSocialChannels(result?.storeInternalData?.total?.social_channels)
                }
              </div>
            </div>
            :
            null
        }
      </div>
    </div>
  );
};

export default StoreOverview;
